<template>
    <div class="smr-pills" :class="`smr-pills--${singleChoice ? 'single' : 'multiple'}`">
        <label class="smr-pills__item" v-for="option in options" :key="option.value">
            <input class="smr-pills__item__input" :type="componentType" v-model="data" :value="option.value" :id="option.value" :disabled="disabled && data.includes(option.value)" @change="inputChangeEventHandler(option, $event)"/>
            <div class="smr-pills__item__content">
                <Icon class="smr-pills__item__icon" :width="20" :height="20" v-if="!singleChoice">
                    <IconCheck/>
                </Icon>
                <div class="smr-pills__item__text chips">{{ option.label }}</div>
            </div>
        </label>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconCheck from '@/components/icons/IconCheck.vue'
import { trackEvent, trackGa4Event } from '@/utils/tracking'
export default {
    components: {
        Icon,
        IconCheck
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        values: {
            type: [Object, Array, String],
            default: () => {}
        },
        minAmount: {
            type: Number,
            default: 0
        },
        singleChoice: {
            type: Boolean,
            default: false
        },
        trackingDataLabel: {
            type: String,
            default: ''
        },
        allowNoSelection: {
            type: Boolean,
            default: false
        },
        trackingDataGa4Event: {
            type: [String, Boolean],
            default: false
        },
        trackingDataValue: {
            type: [String, Boolean],
            default: false
        }
    },
    data() {
        return {
            data: this.singleChoice ? '' : [] 
        }
    },
    created() {
        this.setInitialValues();
    },
    computed: {
        componentType() {
            return this.singleChoice && !this.allowNoSelection ? 'radio' : 'checkbox';
        },
        disabled() {
            return this.minAmount > 0 && this.data.length === this.minAmount
        },
        singleChoiceCheckbox() {
            return this.singleChoice && this.allowNoSelection
        }
    },
    watch: {
        data() {
            this.emitChange();
        },
    },
    methods: {
        setInitialValues() {
            if(this.singleChoiceCheckbox && typeof this.value !== 'object') {
               this.data = [this.values];
            } else {
                this.data = this.values;
            }
        },
        emitChange() {
            if(this.singleChoiceCheckbox) {
                this.$emit('change', this.data[0]);
            } else if(this.singleChoice) {
                this.$emit('change', this.data);
            } else {
                let sortedData = this.data.slice().sort((a, b) => a.localeCompare(b))
                //remove duplicates from sorted data
                sortedData = sortedData.filter(function(elem, index, self) {
                    return index === self.indexOf(elem);
                })
                this.$emit('change', sortedData);
            }
        },

        inputChangeEventHandler(data, event) {
            if(this.singleChoiceCheckbox) {
                this.data = event.target.checked ? [data.value] : ['']
            }
            if(this.trackingDataLabel && event.target.checked) {
                trackEvent({ category: 'Route Planner', action: 'Settings', label: this.trackingDataLabel + ': ' + data.trackingLabel });
                trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: this.trackingDataValue ? `${this.trackingDataValue}-${data.trackingValue}` : data.trackingValue, ga4Parameter2Name: 'tab', ga4Parameter2Value: this.trackingDataLabel.replace(/ /g, "_").toLowerCase(), ga4Event: this.trackingDataGa4Event})
            }
        }
    }
}
</script>

<style lang="scss">
.smr-pills {
    $block: &;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    margin: -3px;
    &__item {
        margin: 3px;
        white-space: nowrap;
        overflow: hidden;
        &__input {
            display: none;
            &:checked {
                & + #{$block}__item__content {
                    background-color: $color-yellow !important;
                    #{$block}__item {
                        &__icon {
                            opacity: 1;
                            transition-duration: 0.2s;
                            & + #{$block}__item__text{
                                transform: translateX(8px);
                            }
                        }
                        
                    }
                }
            }
            &:disabled {
               & + #{$block}__item__content {
                    background-color: $color-grey-silver !important;
                } 
            }
        }
        &__content {
            transition: background-color 0.2s;
            // padding: 8px 20px;
            padding: 8px 24px;
            background-color: $color-black-005;
            border-radius: 30px;
            color: $color-black;
            cursor: pointer;
            position: relative;
            .no-touch &:hover {
                background-color: $color-black-01;
            }
        }
        &__text {
            transition: transform 0.2s $ease-out-quart;
        }
        &__icon {
            transition: 0.2s $ease-out-quart;
            transition-duration: 0.1s;
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0;
        }
    }
}
</style>